import React from 'react'
import { Box, ButtonBase, Link } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'
const useStyles = makeStyles((theme: Theme) => ({
  listHeader: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightBold,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  upperCase: {
    textTransform: 'uppercase',
  },
  deleteAllLink: {
    fontSize: theme.typography.pxToRem(14),
    cursor: 'pointer',
  },
  deleteCloseIcon: {
    fontSize: theme.typography.pxToRem(22),
    cursor: 'pointer',
    fontWeight: theme.typography.fontWeightBold,
  },
  tableRow: {
    borderTop: 'none !important',
    height: 'auto !important',
  },
  tableCellContainer: {
    padding: '0px 16px 21.5px 16px',
  },
  fontRegular: {
    fontWeight: 700,
  },
  itemPadding: {
    padding: '4px 0px !important',
  },
  itemTopMargin: {
    marginTop: theme.spacing(2),
  },
  productStyle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightBold,
    //textWrap: 'nowrap',
  },
  alignRight: {
    textAlign: 'right',
    textWrap: 'nowrap',
  },
  analytesInKitStyle: {
    paddingBlock: '0px 4px',
    width: '95%',
  },
  kitStyle: {
    minWidth: '17.5%',
  },
  flexBasisStyle: {
    flexBasis: '23.5%',
  },
  customPremixStyle: {
    padding: '4.5px 0px !important',
  },
  kitPadding: {
    paddingRight: '10px',
  },
}))
const SkeletonLoader = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.listHeader}>
        <Skeleton variant="text" width={200} height={20} />
        <ButtonBase>
          <Link className={classes.deleteAllLink}>
            <Skeleton variant="text" width={100} height={20} />
          </Link>
        </ButtonBase>
      </div>
      <Box mt={6}>
        <Skeleton variant="rect" width="100%" height={200} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="100%" height={20} />
      </Box>
      <Skeleton variant="rect" width="100%" height={50} />
      <Skeleton variant="rect" width="100%" height={200} />
    </>
  )
}

export default SkeletonLoader
